<template lang="pug">
el-container(style="height: 100vh" direction="vertical")

  el-main
    .registration

      .options
        template(v-if="isVerifiedToken")
          p.dear {{ $t('password_reset.dear', {name:form.name}) }}

        el-select(v-model="$i18n.locale" size="mini" @change="setLocaleSetting")
          el-option(v-for="(lang, index) in languages" :key="index" :value="lang.code" :label="lang.label")

      .logo
        img(:src="images.logo")

      h1 {{ $t('password_reset.title01') }}

      template(v-if="isVerifiedToken")
        p.description
        el-form(label-width="150px" ref="form" :model="form")
          p.item {{ $t('password_reset.name') }}
          p.border {{ form.name }}
          p.item {{ $t('password_reset.email') }}
          p.border {{ managerEmail }}
          p.item {{ $t('password_reset.password') }}
          p.border
            el-input(v-model="form.password" type="password" class="password" :placeholder="$t('password_reset.password_placeholder')")
          p.item {{ $t('password_reset.password_confirmation') }}
          p.border
            el-input(v-model="form.password_confirmation" type="password" class="password" :placeholder="$t('password_reset.password_placeholder')")

          .send
            el-button(type="primary" @click="createManager") {{ $t('password_reset.set_password') }}

      template(v-else)
        p.description
        //- 画面表示が1秒も立たずに切り替わるために何が起こったか分からない。UIとしては不十分なので、5秒程度留めてからの自動移動などにすべき
        h1 {{ $t('password_reset.title02') }}
        p.description {{ $t('password_reset.illegal') }}

  publicFooter
</template>

<script>
import Header from '../public/Header.vue'
import Footer from '../public/Footer.vue'
import API from '@/api/user'
export default {
  data () {
    return {
      isVerifiedToken: false,
      images:{
        logo: require('@/assets/cuona_nolabel_logo.svg')
      },
      form: {
        name: '',
        password: ''
      },
      languages: [
        {code: 'ja', label: '日本語'},
        {code: 'en', label: 'English'}
      ]
    }
  },
  components: {
    'publicHeader': Header,
    'publicFooter': Footer
  },
  computed: {

    // 管理者のメールアドレス
    managerEmail: function() {
      return this.$route.query.email
    },

    // アクティベーショントークン
    activationToken: function() {
      return this.$route.params.token
    }

  },
  mounted() {

    // アクティベーショントークンが正しいか検証
    let that = this;
    API.validatePasswordResetToken(this.managerEmail, this.activationToken)
      .then(function(response) {
        that.form.role = response.role;
        that.form.name = response.name;
        that.form.manager_name = response.manager_name;
        that.isVerifiedToken = response.valid
      })
  },
  methods: {

    // 言語設定を保存
    setLocaleSetting: function() {
      this.$store.dispatch('setLocaleSetting', this.$i18n.locale)
    },

    validate: function()
    {
      let pass  = this.form.password;
      let conf = this.form.password_confirmation;

      if (pass.length < 6) {
        this.$message({ showClose: true, message: this.$t('password_reset.error_password_too_short'), type: 'error' });
        return false;
      }
      if (pass !== conf) {
        this.$message({ showClose: true, message: this.$t('password_reset.error_passwords_dont_match'), type: 'error'});
        return false;
      }
      return true;
    },

    // 管理者作成
    createManager: function()
    {
      if (!this.validate()) {
        return false;
      }

      API.resetPassword(this.managerEmail, this.form.password, this.activationToken)
        .then(() => {
          this.$message({
            showClose: true,
            message: this.$t('password_reset.comp_create_account'),
            type: 'success'
          });
          this.$router.replace({ name: 'password_reset_done', params: { token: this.activationToken } })
        }).catch(() => {
          this.$message({
            showClose: true,
            message: this.$t('password_reset.failed_create_account'),
            type: 'error'
          })
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.registration {
  width: 400px;
  background: #FFF;
  margin: 20px auto 0 auto;
  padding: 30px;
  border-radius: 5px;
  border: 1px solid $border;

  .logo {
    margin: 0 auto 30px auto;
    width: 40%;
  }

  .options {
    margin-bottom: 20px;
    .el-select {
      width: 100px;
      margin-top: -3px;
      float: right;
    }
    p.dear {
      display: inline-block;
      margin: 0;
      font-size: 14px;
      font-weight: bold;
      text-decoration: underline;
    }
  }

  h1 {
    margin: 0;
    font-size: 18px;
    font-weight: normal;
    text-align: center;
  }

  p.description {
    font-size: 13px;
    text-align: center;
    margin-bottom: 30px;
    color: #999;
  }

  .el-form {
    width: 300px;
    margin: 0 auto;

    p.item {
      line-height: 20px;
      font-size: 12px;
      color: #999;
    }

    p.border {
      margin: 0 0 5px 0;
      border-bottom: 1px solid $border;
    }
  }

  .password ::v-deep {
    input {
      border: none;
      padding-left: 0;
      height: 30px;
    }
  }
}

.send {
  margin-top: 30px;
  text-align: center;
}
</style>
